import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { getResetByTag, rem, utilityStyles } from './../../../styles';
var childrenStyles = function childrenStyles() {
  return /*#__PURE__*/css("margin-top:", rem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:childrenStyles;"));
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1u4hpl4",
  styles: "display:inline"
} : {
  name: "6ky2zs-inlineStyles",
  styles: "display:inline;label:inlineStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var inlineStyles = function inlineStyles(_ref2) {
  var inlineChildren = _ref2.inlineChildren;
  if (inlineChildren === true) {
    return _ref;
  }
};
var resetStyles = getResetByTag('div');
var StyledAlertChildren = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1f04ig0"
} : {
  target: "e1f04ig0",
  label: "StyledAlertChildren"
})(resetStyles, childrenStyles, inlineStyles, utilityStyles);
export default StyledAlertChildren;